// src/redux/reducers/ResponsesGroupedByQuestionReducer.js

import {
  FETCH_GROUPED_RESPONSES_REQUEST,
  FETCH_GROUPED_RESPONSES_SUCCESS,
  FETCH_GROUPED_RESPONSES_FAILURE,
} from "../Types";

const initialState = {
  loading: false,
  groupedResponses: [],
  error: null,
};

const ResponsesGroupedByQuestionReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GROUPED_RESPONSES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_GROUPED_RESPONSES_SUCCESS:
      return {
        ...state,
        loading: false,
        groupedResponses: action.payload,
        error: null,
      };

    case FETCH_GROUPED_RESPONSES_FAILURE:
      return {
        ...state,
        loading: false,
        groupedResponses: [],
        error: action.payload,
      };

    default:
      return state;
  }
};

export default ResponsesGroupedByQuestionReducer;
